import { SettingSections } from "interfaces";
import { memo } from "react";
import ChevronRightIcon from "../../icon-components/chevronRight";

interface ISubtitleSettingMenu {
    setSection: (section: string) => void;
}

const SubtitleSettingMenu = ({ setSection }: ISubtitleSettingMenu) => {
    return (
        <div id={SettingSections.subtitlesSettingMenu} className="animate__animated animate__fadeIn pl-p-[14px]">
            <div
                className={`pl-flex pl-items-center pl-cursor-pointer pl-gap-2 pl-pb-3 pl-mb-3 pl-border-b pl-border-b-gray-300 dark:pl-border-b-dark-4`}
                onClick={() => setSection(SettingSections.main)}
            >
                <div className={`pl-rounded-[4px] pl-p-1 pl-bg-gray-300 dark:pl-bg-dark-4`}>
                    <ChevronRightIcon className={`pl-w-3 pl-h-3 pl-stroke-gray-800`} />
                </div>
                <p className="pl-text-[15px] pl-font-medium">تنظیمات زیرنویس</p>
            </div>
            <div className="pl-m-0 pl-flex pl-flex-col pl-p-0 pl-text-gray-100">
                <p
                    className={`pl-pr-2 pl-py-[10px] pl-cursor-pointer pl-text-[12px] pl-text-black dark:pl-text-gray-100 hover:pl-bg-main/[0.1] hover:dark:pl-bg-white/[0.25] pl-rounded-[4px]`}
                    onClick={() => setSection(SettingSections.subtitles)}
                >
                    انتخاب زیرنویس
                </p>
                <p
                    className={`pl-pr-2 pl-py-[10px] pl-cursor-pointer pl-text-[12px] pl-text-black dark:pl-text-gray-100 hover:pl-bg-main/[0.1] hover:dark:pl-bg-white/[0.25] pl-rounded-[4px]`}
                    onClick={() => setSection(SettingSections.subtitlesBackgroundColors)}
                >
                    انتخاب رنگ پس‌زمینه زیرنویس
                </p>

                <p
                    className={`pl-pr-2 pl-py-[10px] pl-cursor-pointer pl-text-[12px] pl-text-black dark:pl-text-gray-100 hover:pl-bg-main/[0.1] hover:dark:pl-bg-white/[0.25] pl-rounded-[4px]`}
                    onClick={() => setSection(SettingSections.subtitlesTextColors)}
                >
                    انتخاب رنگ متن زیرنویس
                </p>
            </div>
        </div>
    );
};

export default memo(SubtitleSettingMenu);
